// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const quagsire: PokeData = {
  "id": 195,
  "name": "quagsire",
  "height": 14,
  "weight": 750,
  "base_experience": 151,
  "types": [
    PokeType.WATER,
    PokeType.GROUND
  ],
  "api_moves": [
    "slam",
    "tail-whip",
    "mist",
    "water-gun",
    "earthquake",
    "toxic",
    "haze",
    "amnesia",
    "rain-dance",
    "yawn",
    "mud-sport",
    "muddy-water",
    "mud-shot",
    "aqua-tail",
    "mud-bomb"
  ],
  "moves": [
    "earthquake",
    "rain-dance",
    "mud-shot",
    "aqua-tail",
    "mud-bomb",
    "bonemerang",
    "water-spout",
    "fissure",
    "hydro-pump",
    "magnitude",
    "life-dew",
    "mud-slap",
    "rototiller"
  ],
  "evolution_chain": {
    "id": 96,
    "item": null,
    "species": [
      {
        "name": "wooper",
        "order": 225,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "quagsire",
        "order": 226,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 194,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "clodsire",
        "order": 1009,
        "types": [
          PokeType.POISON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 194,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 166,
    "speed": 68,
    "ability_power": 166
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
